import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'semd-modal',
    templateUrl: './semd-modal.component.html',
    styleUrls: ['./semd-modal.component.scss'],
    standalone: false
})
export class SemdModalComponent {
    @Input() public data: Array<string> | null = null;
    public constructor(public activeModal: NgbActiveModal) {}
    public closeApp(event: MouseEvent) {
        event.stopPropagation();
        this.activeModal.close();
    }
}
